import { analytics } from '@/firebase'

export default class AnalyticsService
{
	private enabled = true

	constructor()
	{
		this.enabled = process.env.NODE_ENV === 'production'
	}

	setUserId(id: string)
	{
		if (!this.enabled || !analytics)
		{
			return
		}
		analytics.setUserId(id)
	}

	setUserProperties(props: {})
	{
		if (!this.enabled || !analytics)
		{
			return
		}
		analytics.setUserProperties(props)
	}

	setCurrentScreen(screenName: string)
	{
		if (!this.enabled || !analytics)
		{
			return
		}
		analytics.setCurrentScreen(screenName)
	}

	logScreenView(screenName: string)
	{
		this.logEvent('screen_view', {
			screen_name: screenName
		})
	}

	logSelectContent(itemName: string, type: string)
	{
		this.logEvent('select_content', {
			items: itemName,
			content_type: type
		})
	}

	logTimingComplete(name: string, value: number)
	{
		this.logEvent('timing_complete', {
			name,
			value
		})
	}

	logLogin(method: string = 'email')
	{
		this.logEvent('login', {
			method
		})
	}

	logSignUp(method: string = 'email')
	{
		this.logEvent('sign_up', {
			method
		})
	}

	logPageView()
	{
		this.logEvent('page_view')
	}

	logEvent(name: string, eventParams?: {})
	{
		if (!this.enabled || !analytics)
		{
			console.log(`[DEBUG] logEvent(${name})`)
			if (eventParams && Object.keys(eventParams).length > 0)
			{
				console.log('With params:')
				console.dir(eventParams)
			}
			return
		}

		analytics.logEvent(name, eventParams)
	}
}

const sharedInstance = new AnalyticsService()

export {
	sharedInstance
}
